<template lang="html">
  <div>
    <v-container column>
      <v-card elevation="6" color="white" class="col">
        <div id="title" v-html="this.$t('youtube.TITLE')"></div>
        <v-card-text>
          <iframe
            width="560"
            height="315"
            :src="
              (this.url[this.lang] ? this.url[this.lang] : this.url.en) +
                '?autoplay=1&loop=1&mute=0&controls=1'
            "
            title="YouTube video player"
            autoplay="1"
            frameborder="0"
            mute="0"
            loop="1"
            controls="1"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lang: navigator.language.slice(0, 2),
      url: {
        en: 'https://www.youtube.com/embed/EbDN3hizw80',
        fr: 'https://www.youtube.com/embed/55DFzShZnQ8',
        de: 'https://www.youtube.com/embed/O0VIXpcjBkQ',
        pt: 'https://www.youtube.com/embed/CzWkbBlQiHY ',
        ru: 'https://www.youtube.com/embed/noSAdtrNObI',
        it: 'https://www.youtube.com/embed/1QZDjqf7Fhc ',
        es: 'https://www.youtube.com/embed/mtov6IPGTl4 ',
        uk: 'https://www.youtube.com/embed/DY80eTCHmW8',
        nl: 'https://www.youtube.com/embed/EbDN3hizw80',
        pl: 'https://www.youtube.com/embed/EbDN3hizw80'
      }
    }
  }
}
</script>

<style lang="css" scoped>
div {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
}
.col {
  flex-direction: column;
}

#title {
  font-size: 32px;
  font-weight: 600;
  text-transform: capitalize;
}
</style>
